import React from 'react'

import { ListItem } from 'material-ui/List'
import Divider from 'material-ui/Divider'

import ChatRoomAvatar from './ChatRoomAvatar'
import ImageAvatar from './ImageAvatar'
import MessagesUtils from '../infra/MessagesUtils'

import teamGeneralIcon from '../resources/chat_general_icon.png'
import teamRandomIcon from '../resources/chat_random_icon.png'

const getRoomSubtitle = lastMessage => {
  if (!lastMessage || !lastMessage.metadata) {
    return null
  }
  if (lastMessage.metadata.type === 'text') {
    return `${lastMessage.senderName}: ${lastMessage.metadata.text}`
  }
  if (lastMessage.metadata.type === 'image') {
    return `${lastMessage.senderName} sent a photo`
  }
  return null
}

const getRoomImageResource = type => {
  switch (type) {
    case 'team_general':
      return teamGeneralIcon
    case 'team_random':
      return teamRandomIcon
  }
}

const ChatRoomListItem = (props) => {
  const title = props.metadata.title || MessagesUtils.createTitleFromMembers(props.members, props.thisUser.value)
  const unRead = props.unRead ? 'bold' : 'normal'
  const selected = props.selected ? 'rgba(0, 0, 0, 0.1)' : 'transparent'
  const subtitle = getRoomSubtitle(props.lastMessage)
  const roomAvatar = props.roomInfo.type === 'team_random' || props.roomInfo.type === 'team_general'
    ? <ImageAvatar
      size={50}
      style={{ top: 11, alignSelf: 'center' }}
      backgroundColor={props.roomInfo.color}
      imageSource={getRoomImageResource(props.roomInfo.type)} />
    : <ChatRoomAvatar
      members={props.roomInfo.avatarMembers}
      size={50}
      style={{ top: 11, alignSelf: 'center' }} />
  return (
    <div>
      <ListItem
        style={{ backgroundColor: selected }}
        value={props.roomInfo.dbKey}
        leftAvatar={roomAvatar}
        primaryText= {
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              fontWeight: unRead
            }}>
            <div
              style={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                fontSize: 15,
              }}>
              { title }
            </div>
            <span
              style={{
                marginLeft: 10,
                fontSize: 14,
                color: '#a7abaf',
                overflow: 'visible',
                whiteSpace: 'nowrap'
              }}>
              { props.timeStr }
            </span>
          </div>
        }
        secondaryText={
          <p
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              fontWeight: unRead
            }}>
            { subtitle }
          </p>
        }
        secondaryTextLines={1}
        onTouchTap={props.onPress}
      />
      <Divider />

    </div>


  )
}

export default ChatRoomListItem



// WEBPACK FOOTER //
// ./src/chat/ChatRoomListItem.js